import type { PatientSuggestionResponse } from "../../../Types/VoiceAssistant/PatientSuggestionTypes";
import type { ResponseType } from "../../../Types/ServicesType/servicesType";
import type { VoicePromptResponseBody } from "../../../Types/VoiceAssistant/VoiceAssistantTypes";

export const PATIENT_SUGGESTION_PROMPT =
  "Generate clinical suggestions for this patient encounter";

function isSuggestionResponse(value: unknown): value is PatientSuggestionResponse {
  if (!value || typeof value !== "object") return false;
  const record = value as PatientSuggestionResponse;
  return (
    Array.isArray(record.diagnosis) ||
    Array.isArray(record.suggestedDrugs) ||
    Array.isArray(record.prescription) ||
    Boolean(record.services) ||
    record.resultType != null
  );
}

export function parsePatientSuggestionResponse(
  result: ResponseType<VoicePromptResponseBody>,
): PatientSuggestionResponse | null {
  if (result.responseIndicator !== "success" || !result.response) return null;

  const body = result.response;
  if (isSuggestionResponse(body)) {
    return body;
  }

  if (body.data && typeof body.data === "object" && !Array.isArray(body.data)) {
    return {
      data: body.data as PatientSuggestionResponse["data"],
      type: body.type ?? "suggestion",
    };
  }

  return null;
}

export function hasSuggestionContent(suggestion: PatientSuggestionResponse | null): boolean {
  if (!suggestion) return false;
  return (
    (suggestion.diagnosis?.length ?? 0) > 0 ||
    (suggestion.suggestedDrugs?.length ?? 0) > 0 ||
    (suggestion.prescription?.length ?? 0) > 0 ||
    (suggestion.services?.lab?.length ?? 0) > 0
  );
}
